import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["variant", "weight", "color", "children", "style", "wide", "component", "noWrap", "truncateLines", "className", "classes"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import classnames from "classnames";
import { Typography as MuiTypography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { RaiseColors } from "componentLibrary/theme/RaiseColors";
import { CustomRaiseTypography } from "componentLibrary/theme/RaiseTypography";

/* These are a subset of Material UI's built in Typography variants. We define our own variants
 * to limit the API to only font variants that are defined in `muiTheme.typography`.
 * When defining a new variant type:
 *
 * 1. Make sure they are part of MUI's variant subset - https://v4.mui.com/api/typography/#typography-api
 * 2. Add the variant string to this type
 * 3. Define the variant in RaiseTypography
 * 4. Override the variant in muiTheme -> typography -> 'variantName': RaiseTypography.variantName
 */
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles({
  regular: {
    fontWeight: 400
  },
  medium: {
    fontWeight: 500
  },
  semibold: {
    fontWeight: 600
  },
  bold: {
    fontWeight: 700
  },
  extrabold: {
    fontWeight: 800
  },
  wide: {
    letterSpacing: "0.8px",
    textTransform: "uppercase"
  }
});

// Add truncate styles to the typography component
// Truncate long strings to a certain number of lines
var getTruncateStyles = function getTruncateStyles(lines) {
  return {
    display: "-webkit-box",
    WebkitLineClamp: lines,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis"
  };
};

// MUIv4 does not support custom Typography variant names so we need to override as styles
var useCustomTypographyVariants = makeStyles(_objectSpread({}, CustomRaiseTypography));
var Typography = function Typography(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "body2" : _ref$variant,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "regular" : _ref$weight,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? RaiseColors.glacier2400 : _ref$color,
    children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$wide = _ref.wide,
    wide = _ref$wide === void 0 ? false : _ref$wide,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? "span" : _ref$component,
    noWrap = _ref.noWrap,
    truncateLines = _ref.truncateLines,
    className = _ref.className,
    muiClasses = _ref.classes,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var customTypography = useCustomTypographyVariants();
  var useCustomTypography = variant in customTypography;
  return /*#__PURE__*/_jsx(MuiTypography, _objectSpread(_objectSpread({
    variant: useCustomTypography ? "inherit" : variant,
    className: classnames(className, classes[weight], _defineProperty(_defineProperty({}, classes.wide, wide), customTypography[variant], useCustomTypography)),
    classes: muiClasses
    // inline these styles to improve performance. Passing functions to makeStyles is really slow
    ,
    style: _objectSpread(_objectSpread({
      color: color,
      whiteSpace: noWrap ? "nowrap" : "pre-wrap"
    }, truncateLines ? getTruncateStyles(truncateLines) : {}), style),
    noWrap: noWrap,
    component: component
  }, props), {}, {
    children: children
  }));
};
export default Typography;